import { CRUD } from "@/shared/components";
import {
  LanguagesListQuery,
  LanguageShowQuery,
  DeleteLanguagesMutation,
  RestoreLanguagesMutation,
} from "@/admin/entities/languages";
import { useLanguagesManagement, type LanguageRow } from "../model";
import * as LanguagesSchemas from "../model/schemas";
import { createEditSchema } from "../model/schemas";
import { LanguageShowComponent } from "@/admin/features/languages";

export function Languages() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useLanguagesManagement();

  return (
    <CRUD<LanguageRow>
      listQuery={LanguagesListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={LanguagesSchemas.filterSchema}
      createSchema={LanguagesSchemas.createSchema}
      editSchema={createEditSchema(LanguageShowComponent)}
      editQuery={LanguageShowQuery}
      deleteMutation={DeleteLanguagesMutation}
      restoreMutation={RestoreLanguagesMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
